<template>
  <div style="border: 1px solid #DFDFDF; border-radius: 6px; padding: 8px 8px 8px 4px;">
    <LineChart :chart-data="chartData" :chart-options="chartOptions" style="height: 250px"/>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

Chart.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export default {
  components: {
    LineChart: Line
  },
  props:{
    graphData: {
      required: true,
    }
  },
  computed:{
    pipelineLeadsData(){
      const data = this.graphData?.pipeline_leads_series;
      return data ? Object.values(data) : [];
    },
    siteVisitLeadsData(){
      const data = this.graphData?.site_visit_leads_series;
      return data ? Object.values(data) : [];
    },
    bookingLeadsData(){
      const data = this.graphData?.booking_leads_series;
      return data ? Object.values(data) : [];
    },
    labels(){
      const data = this.graphData?.pipeline_leads_series;
      return data ? Object.keys(data).map(date => this.$moment(date).format('DD MMM YY')):[];
    },
    pipelineAmount(){
      const data = this.graphData?.pipeline_amount_series;
      return data ? Object.values(data) : [];
    },

    chartData(){
      return {
        labels: this.labels,
        datasets: [
          {
            label: 'PIPELINE LEADS',
            data: [...this.pipelineLeadsData],
            borderColor: '#2C6175',
            pointBackgroundColor: '#2C6175',
            fill: false,
            tension: 0.1,
            pipelineAmount: this.pipelineAmount,
            pointStyle: 'rect',
            borderWidth:2
          },
          {
            label: 'SITE VISIT LEADS',
            data: [...this.siteVisitLeadsData],
            borderColor: '#A4A834',
            pointBackgroundColor: '#A4A834',
            fill: false,
            tension: 0.1,
            pointStyle: 'rect',
            borderWidth:2
          },
          {
            label: 'BOOKING LEADS',
            data: [...this.bookingLeadsData],
            borderColor: '#cf173f',
            pointBackgroundColor: '#cf173f',
            fill: false,
            tension: 0.1,
            pointStyle: 'rect',
            borderWidth:2
          }
        ]
      }
    }
  },
  data() {
    let vm = this;
    return {
      color:['#2C6175','#A4A834','#cf173f'],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          legend: {
            display: true,
            labels: {
            usePointStyle: true,
            pointStyle: 'rectRounded',
            }
          },
           tooltip: {
						position: "nearest",
						xAlign: "bottom",
            bodySpacing: 5,
            backgroundColor: '#fff',
            titleColor: '#030303',
            usePointStyle: true,
            borderColor:'rgba(0, 0, 0, 0.06)',
            borderWidth: 1,
            titleColor: "#585858",
            titleMarginBottom: 8,
            padding: 8,
            cornerRadius: 4,
            caretSize: 0,
            displayColors: true,
            boxWidth: 8,
            boxHeight: 8,
            titleFont:{
              size: 11,
              lineHeight: 1.5,
              weight: 400,
            },
            bodyFont:{
              size: 11,
              lineHeight: 1,
              weight: 400
            },
            callbacks: {
              labelColor: function (context) {
                return {
                  backgroundColor: vm.color[context.datasetIndex],
                  borderWidth: 1
                };
              },
              labelTextColor: function () {
                return '#333333';
              },
              title: function (context) {
                return `${context[0].label}`;
              },
              afterTitle: function (context) {
                return `Pipeline Amount: ${vm.pipelineAmount[context[0].dataIndex]}`;
              },
            }
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              display: true
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'PIPELINE LEADS'
            },
          }
        },
      }
    };
  }
};
</script>
